	
$('.js-collection-carousel').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    prevArrow: "<a href='#' class='slick-prev slick-arrow'><i class='fa fa-chevron-left'></i></a>",
   	nextArrow: "<a href='#' class='slick-next slick-arrow'><i class='fa fa-chevron-right'></i></a>",
	responsive: [     
  {
      breakpoint: 1024,
      settings: {
       	slidesToShow: 3,
   		slidesToScroll: 3,
      }
    },
        {
      breakpoint: 768,
      settings: {
       	slidesToShow: 2,
   		slidesToScroll: 2,
      }
    },
    {
      breakpoint: 600,
        centerMode: true,
		centerPadding: '60px',
      	settings: {
        slidesToShow: 1,
		slidesToScroll: 1,
		dots:true,
		arrows:true,

      }
    }
  ]  	
});

// PDP CAROUSEL WITH THUMBS
$('.js-slider-primary').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  fade: true,
  adaptiveHeight: true,
  asNavFor: '.js-slider-nav'
});
$('.js-slider-nav').slick({
  slidesToScroll: 1,
  asNavFor: '.js-slider-primary',
  dots: false,
  focusOnSelect: true,
  arrows: true,
  infinite: true,
  slidesToShow: 3,
  vertical: true,
  prevArrow: "<a href='#' class='previous-arrow'><i class='fal fa-chevron-up'></i></a>",
  nextArrow: "<a href='#' class='next-arrow'><i class='fal fa-chevron-down'></i></a>",
  responsive: [
      {
        breakpoint: 768,
        settings: {
          vertical: false,
          prevArrow: "<a href='#' class='previous-arrow'><i class='fal fa-chevron-left'></i></a>",
          nextArrow: "<a href='#' class='next-arrow'><i class='fal fa-chevron-right'></i></a>",
        }
      }
    ]
});

